var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuria(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.246,
    height: 48.851,
    viewBox: "0 0 90.246 48.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10366",
    "data-name": "Path 10366",
    d: "M990.119,1278.3c-14.432-8.357-7.622-3.23-21.958-.269-6.6.939-7.69-5.665-16.071-1.6-1.18.941-3.346-1.487-4.184-2.045-2.489-2.055-8.21-2.276-8.092-6.369-12.469-6.951-17.3,4.305-17.907-16.241-13.163-17.646,16.983-20.61,28.735-18.177,4.9,4.6,10.416,2.884,15.732,6.561-5.2,5.507,2.265,7.433,6.5,8.1,10.268-7.507,7.623,7.081,16.907,7.868,4.125,3.786,9.259,5.079,14.49,5.75,1.334,5.517,3.962,12.153-2.876,13.5C999.669,1282.033,995.6,1276.417,990.119,1278.3Z",
    transform: "translate(-917.134 -1231.346)",
    fill: "#23262c",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuria);
export default __webpack_public_path__ + "static/media/guria.a757fe31cb62044d6042fc06734225cb.svg";
export { ForwardRef as ReactComponent };